// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-main {
  display: flex;
  width: 100%;
  padding: 0 4vh;
}

.terms-para {
  font-size: 1.3vw;
  font-weight: 400;
  color: #fff;
}
@media (max-width: 768px) {
  .terms-para {
    font-size: 1.75rem;
  }
}

.term-tab .ant-tabs-nav {
  border-radius: 1.4vh;
  background: linear-gradient(45deg, rgb(255, 182, 160), rgb(240, 89, 42), rgb(37, 60, 119)) !important;
  padding: 2px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-tabs-left > .ant-tabs-content-holder,
.ant-tabs-left > div > .ant-tabs-content-holder {
  border-left: none !important;
}

.term-tab .ant-tabs-nav-wrap {
  background: #1d1a36;
  border-radius: 1.4vh;
  padding: 1.3vw;
}

.term-tab .ant-tabs-tab {
  height: 100%;
  font-size: 1.2vw;
  font-weight: 400;
  color: #fff;
  border-right: 1px solid #fff !important;
}
@media (max-width: 1024px) {
  .term-tab .ant-tabs-tab {
    font-size: 1.1rem;
  }
}
@media (max-width: 767px) {
  .term-tab .ant-tabs-tab {
    border-right: none !important;
    border-bottom: 1px solid #fff !important;
  }
}

.term-tab .ant-tabs-tab:hover {
  color: #f0592a;
}

.term-tab .ant-tabs-tab-active {
  font-size: 1.3vw;
  font-weight: 400;
  filter: none;
  opacity: 1;
  color: #f0592a !important;
}
@media (max-width: 1024px) {
  .term-tab .ant-tabs-tab-active {
    font-size: 1.1rem;
  }
}

.term-tab .ant-tabs-ink-bar::after {
  background: #f0592a !important;
  height: 100% !important;
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
@media (max-width: 767px) {
  .term-tab .ant-tabs-ink-bar::after {
    height: 4px !important;
  }
}

.termTabGradCol1 {
  margin-bottom: 0px;
  min-height: 122vh;
}
@media (max-width: 767px) {
  .termTabGradCol1 {
    min-height: 60vh;
  }
}

.termTabGradCol2 {
  text-align: left;
  padding: 2vw;
  min-height: 115.5vh;
}
@media (max-width: 767px) {
  .termTabGradCol2 {
    min-height: 55.5vh;
  }
}

.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #f0592a !important;
  text-shadow: 0 0 0.25px currentcolor;
}

.ant-tabs-tab-btn:focus:not(:focus-visible),
.ant-tabs-tab-remove:focus:not(:focus-visible) {
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/TermsTab/termsTab.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AACF;AAAE;EAJF;IAKI,kBAAA;EAGF;AACF;;AAAA;EACE,oBAAA;EACA,qGAAA;EAMA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;;EAEE,4BAAA;AAFF;;AAKA;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,uCAAA;AAFF;AAGE;EANF;IAOI,iBAAA;EAAF;AACF;AACE;EATF;IAUI,6BAAA;IACA,wCAAA;EAEF;AACF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAEF;AADE;EANF;IAOI,iBAAA;EAIF;AACF;;AADA;EACE,8BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAIF;AAHE;EARF;IASI,sBAAA;EAMF;AACF;;AAHA;EACE,kBAAA;EACA,iBAAA;AAMF;AALE;EAHF;IAII,gBAAA;EAQF;AACF;;AALA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;AAQF;AAPE;EAJF;IAKI,kBAAA;EAUF;AACF;;AAPA;EACE,yBAAA;EACA,oCAAA;AAUF;;AAPA;;EAEE,sBAAA;AAUF","sourcesContent":[".terms-main {\n  display: flex;\n  width: 100%;\n  padding: 0 4vh;\n}\n\n.terms-para {\n  font-size: 1.3vw;\n  font-weight: 400;\n  color: #fff;\n  @media (max-width: 768px) {\n    font-size: 1.75rem;\n  }\n}\n\n.term-tab .ant-tabs-nav {\n  border-radius: 1.4vh;\n  background: linear-gradient(\n    45deg,\n    rgba(255, 182, 160, 1),\n    rgba(240, 89, 42, 1),\n    rgba(37, 60, 119, 1)\n  ) !important;\n  padding: 2px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-tabs-left > .ant-tabs-content-holder,\n.ant-tabs-left > div > .ant-tabs-content-holder {\n  border-left: none !important;\n}\n\n.term-tab .ant-tabs-nav-wrap {\n  background: #1d1a36;\n  border-radius: 1.4vh;\n  padding: 1.3vw;\n}\n\n.term-tab .ant-tabs-tab {\n  height: 100%;\n  font-size: 1.2vw;\n  font-weight: 400;\n  color: #fff;\n  border-right: 1px solid #fff !important;\n  @media (max-width: 1024px) {\n    font-size: 1.1rem;\n  }\n  @media (max-width: 767px) {\n    border-right: none !important;\n    border-bottom: 1px solid #fff !important;\n  }\n}\n\n.term-tab .ant-tabs-tab:hover {\n  color: #f0592a;\n}\n\n.term-tab .ant-tabs-tab-active {\n  font-size: 1.3vw;\n  font-weight: 400;\n  filter: none;\n  opacity: 1;\n  color: #f0592a !important;\n  @media (max-width: 1024px) {\n    font-size: 1.1rem;\n  }\n}\n\n.term-tab .ant-tabs-ink-bar::after {\n  background: #f0592a !important;\n  height: 100% !important;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  @media (max-width: 767px) {\n    height: 4px !important;\n  }\n}\n\n.termTabGradCol1 {\n  margin-bottom: 0px;\n  min-height: 122vh;\n  @media (max-width: 767px) {\n    min-height: 60vh;\n  }\n}\n\n.termTabGradCol2 {\n  text-align: left;\n  padding: 2vw;\n  min-height: 115.5vh;\n  @media (max-width: 767px) {\n    min-height: 55.5vh;\n  }\n}\n\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #f0592a  !important;\n  text-shadow: 0 0 0.25px currentcolor;\n}\n\n.ant-tabs-tab-btn:focus:not(:focus-visible),\n.ant-tabs-tab-remove:focus:not(:focus-visible) {\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
